import { Injectable } from '@angular/core';
import { MwCoreDateTimeService } from '@core/services';
import { TranslateService } from '@ngx-translate/core';

export enum RangeEnum {
  Today,
  ThisWeek,
  ThisMonth,
  LastWeek,
  LastMonth,
}

interface DateRangeObjInterface {
  label: string;
  start: Date;
  end: Date;
}

@Injectable()
export class MwDateRangePickerPredefinedRangesService {
  readonly range: {
    [id: number]: DateRangeObjInterface;
  } = {};

  get today(): DateRangeObjInterface {
    return this.range[RangeEnum.Today];
  }

  get thisWeek(): DateRangeObjInterface {
    return this.range[RangeEnum.ThisWeek];
  }

  get thisMonth(): DateRangeObjInterface {
    return this.range[RangeEnum.ThisMonth];
  }

  get lastWeek(): DateRangeObjInterface {
    return this.range[RangeEnum.LastWeek];
  }

  get lastMonth(): DateRangeObjInterface {
    return this.range[RangeEnum.LastMonth];
  }

  get ranges(): DateRangeObjInterface[] {
    return Object.values(this.range);
  }

  constructor(
    private dateTimeService: MwCoreDateTimeService,
    private translateService: TranslateService
  ) {
    this.setupRanges();
    this.translateRanges();
  }

  private setupRanges(): void {
    const now = new Date();
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastWeek = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 7
    );

    this.range[RangeEnum.Today] = {
      label: 'today',
      ...this.dateTimeService.getDayRange(),
    };
    this.range[RangeEnum.ThisWeek] = {
      label: 'this_week',
      ...this.dateTimeService.getWeekRange(),
    };
    this.range[RangeEnum.ThisMonth] = {
      label: 'this_month',
      ...this.dateTimeService.getMonthRange(),
    };
    this.range[RangeEnum.LastWeek] = {
      label: 'last_week',
      ...this.dateTimeService.getWeekRange(lastWeek),
    };
    this.range[RangeEnum.LastMonth] = {
      label: 'last_month',
      ...this.dateTimeService.getMonthRange(lastMonth),
    };
  }

  private translateRanges(): void {
    const prefix = 'CORE.COMPONENT.DATE_RANGE_PICKER.RANGES';
    for (const key in this.range) {
      if (this.range[key]) {
        const label = this.range[key].label;
        this.range[key].label = this.translateService.instant(
          `${prefix}.${label}`
        );
      }
    }
  }
}
